// extracted by mini-css-extract-plugin
export default {"list_item":"feature-list-item_list_item__I82CO"};